import update from 'immutability-helper';
import type { FC } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { FormField, ItemTypes } from '../types';
import DynamicFormField from './DynamicFormField';
import { useDrop } from 'react-dnd';

export interface Item {
  id: number;
  text: string;
}

export interface ContainerState {
  cards: Item[];
}
export interface ContainerProps {
  formFields: FormField[];
  preview?: boolean;
  onChange: (formfields: FormField[]) => void;
  onEditField?: (fornField: FormField, index: number) => void;
  onFieldValueChange?: (fornField: FormField, index: number) => void;
  disableDrag: boolean;
  disabled: boolean;
  className?: string;
}

export const Container: FC<ContainerProps> = ({
  formFields,
  preview,
  onChange,
  onEditField,
  onFieldValueChange,
  disableDrag,
  disabled,
  className,
}) => {
  {
    const [fFields, setFields] = useState<FormField[]>([]);
    useEffect(() => {
      if (formFields) {
        setFields([...formFields]);
      }
    }, [formFields]);

    // useEffect(() => {
    //   if (fFields) {
    //     onChange(fFields);
    //   }
    // }, [fFields]);
    const findCard = useCallback(
      (fieldName: string) => {
        const card = fFields.filter((c) => `${c.fieldName}` === fieldName)[0];
        return {
          card,
          index: fFields.indexOf(card),
        };
      },
      [fFields]
    );

    const moveCard = useCallback(
      (id: string, atIndex: number) => {
        const { card, index } = findCard(id);

        if (card) {
          onChange(
            update(fFields, {
              $splice: [
                [index, 1],
                [atIndex, 0, card],
              ],
            })
          );
        }
      },
      [findCard, fFields, setFields]
    );

    const onDeleteField = (formField: FormField, index: number) => {
      fFields.splice(index, 1);
      //setFields([...fFields]);
      onChange(fFields);
    };

    const [, drop] = useDrop(() => ({ accept: ItemTypes.CARD }));

    return (
      <div className={`wrapper ${className}`}>
        <div ref={drop} className="petsked-form fields-container">
          {fFields.map((formField, i) => (
            <>
              <DynamicFormField
                id={formField.fieldName}
                index={i}
                key={`form-dynamic${i}`}
                data={formField}
                moveCard={moveCard}
                disableDrag={disableDrag}
                findCard={findCard}
                onDeleteField={() => onDeleteField && onDeleteField(formField, i)}
                onEditField={() => onEditField && onEditField(formField, i)}
                onFieldValueChange={() => onFieldValueChange && onFieldValueChange(formField, i)}
                disabled={disabled}
                editable={preview ? false : true}
              />
            </>
          ))}
        </div>
      </div>
    );
  }
};
